module.exports = __webpack_public_path__ + "img/Iconen Class Action website-01.64062d08.svg";